import { CaretLeft, CaretRight } from "@phosphor-icons/react";

const PAGE_SIZES = [10, 25, 50, 100];

export default function Pagination({
  page,
  pageSize,
  total,
  onPageChange,
  onPageSizeChange,
  testId = "pagination",
}) {
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  const safePage = Math.min(Math.max(1, page), totalPages);
  const from = total === 0 ? 0 : (safePage - 1) * pageSize + 1;
  const to = Math.min(safePage * pageSize, total);

  // Build page numbers with ellipsis for compactness
  const pageNums = (() => {
    const out = [];
    const window = 1; // pages on each side of current
    for (let i = 1; i <= totalPages; i++) {
      if (
        i === 1 ||
        i === totalPages ||
        (i >= safePage - window && i <= safePage + window)
      ) {
        out.push(i);
      } else if (out[out.length - 1] !== "…") {
        out.push("…");
      }
    }
    return out;
  })();

  return (
    <div
      className="flex flex-wrap items-center justify-between gap-3 py-3 px-4 border-t border-slate-200 bg-slate-50/50"
      data-testid={testId}
    >
      <div className="text-sm text-slate-600 tabular-nums">
        {total === 0 ? (
          "Brak wpisów"
        ) : (
          <>
            Pokazano <b>{from}</b>–<b>{to}</b> z <b>{total}</b>
          </>
        )}
      </div>

      <div className="flex items-center gap-2">
        <label className="text-xs text-slate-600 hidden sm:inline">Na stronie:</label>
        <select
          value={pageSize}
          onChange={(e) => onPageSizeChange(Number(e.target.value))}
          className="text-sm border border-slate-300 rounded-md px-2 py-1 bg-white"
          data-testid={`${testId}-page-size`}
        >
          {PAGE_SIZES.map((s) => (
            <option key={s} value={s}>
              {s}
            </option>
          ))}
        </select>

        <div className="flex items-center gap-1 ml-2">
          <button
            type="button"
            onClick={() => onPageChange(safePage - 1)}
            disabled={safePage <= 1}
            className="p-1.5 rounded-md hover:bg-slate-200 disabled:opacity-40 disabled:cursor-not-allowed"
            aria-label="Poprzednia strona"
            data-testid={`${testId}-prev`}
          >
            <CaretLeft className="w-4 h-4" weight="bold" />
          </button>
          {pageNums.map((p, i) =>
            p === "…" ? (
              <span key={`e-${i}`} className="px-2 text-slate-400">
                …
              </span>
            ) : (
              <button
                key={p}
                type="button"
                onClick={() => onPageChange(p)}
                className={`min-w-[2rem] px-2 py-1 rounded-md text-sm font-medium ${
                  p === safePage
                    ? "bg-blue-600 text-white"
                    : "text-slate-700 hover:bg-slate-200"
                }`}
                data-testid={`${testId}-page-${p}`}
              >
                {p}
              </button>
            )
          )}
          <button
            type="button"
            onClick={() => onPageChange(safePage + 1)}
            disabled={safePage >= totalPages}
            className="p-1.5 rounded-md hover:bg-slate-200 disabled:opacity-40 disabled:cursor-not-allowed"
            aria-label="Następna strona"
            data-testid={`${testId}-next`}
          >
            <CaretRight className="w-4 h-4" weight="bold" />
          </button>
        </div>
      </div>
    </div>
  );
}
